/** Select Service.
 *
 *  Used to select a set of features using a given geometry.
 *
 */
function SelectService(Application, options) {
    /** Define the title of the service. */
    this.title = options.title ? options.title : 'Select';

    /** Title to show at the top of the results. */
    this.resultsTitle = options.resultsTitle ? options.resultsTitle : 'Select Results';

    /** Header template for rendering before features. */
    this.headerTemplate = options.headerTemplate ? options.headerTemplate : '@select-header';

    /** Template to use for rendering returned features. */
    this.template = options.template ? options.template : '@select';

    /** Toggle whether the grid should attempt rendering. */
    this.showGrid = options.showGrid !== undefined ? options.showGrid : false;

    /** Footer template for rendering before features. */
    this.footerTemplate = options.footerTemplate ? options.footerTemplate : '@select-footer';

    /** Name will be set by the application when the service is registered. */
    this.name = options.name ? options.name : "select";

    /** Define the highlight layer */
    this.highlightPath = options.highlightPath ? options.highlightPath : 'parcel_data/highlight';
    this.resultsPath = options.resultsPath ? options.resultsPath : 'results/results';

    /** Limit the number of selection tools available */
    this.tools = options.tools ? options.tools : {
        'Point': true,
        'MultiPoint': false,
        'Polygon': true,
        'LineString': false,
        'Select': true,
        'Modify': false,
        'default': 'Point',
        'buffer': true
    };

    /** autoGo = true instructs the service to query whenever
     *                the geometry has changed.
     */
    this.autoGo = options.autoGo ? options.autoGo : false;

    /** keepAlive = true will keep the service in 'query mode'
     *                   in the background, until it is explictly turned off.
     */
    this.keepAlive =  options.keepAlive ? options.keepAlive : false;

    /** User input fields, select allows choosing a layer */
    this.fields = options.fields || [{
        type: 'layers-list',
        name: 'layer',
        label: 'Query Layer',
        default: options.defaultLayer,
        filter: {
            // ensure that the layer is visible to prevent confusion.
            requireVisible: false,
            // but require it have a select template.
            withTemplate: ['select', 'select-header']
        }
    }];

    /** Alow shapes to be buffered. */
    this.bufferAvailable = options.bufferAvailable ? options.bufferAvailable : true;

    /** This function is called everytime there is an select query.
     *
     *  @param selection contains a GeoJSON feature describing the
     *                   geography to be used for the query.
     *
     *  @param fields    is an array containing any user-input
     *                   given to the service.
     */
    this.query = function(selection, fields) {
        if (selection === undefined || typeof (selection) === 'undefined') {
            // throw up this handy dialog.
            var msg = 'A selection geometry is required for this query.';
            var service_name = this.name;
            var on_close = function() {
                Application.startService(service_name);
            };

            Application.alert('selection-required', msg, on_close);
        } else {
            // get the query layer.
            var query_layer = "parcel_data_wfs/parcels";

            // check which templates should try and load
            var templates = [this.template];
            if(this.showGrid) {
                templates.push('@gridColumns');
                templates.push('@gridRow');
            }

            // dispatch the query against on the query layer!
            Application.dispatchQuery(this.name, selection, [], [query_layer], templates);
        }
    }


    /** resultsAsHtml is the function used to populate the Service Tab
     *                after the service has finished querying.
     */
    this.resultsAsHtml = function(queryId, query) {
        // initialize empty html content.
        var html = '';


        // iterate through each layer that was queried by the service.
        for(var i = 0, ii = query.layers.length; i < ii; i++) {
            // short-handing the item in the loop.
            var path = query.layers[i];

            // add the header contents
            html += Application.renderTemplate(path, this.headerTemplate, query);

            // check to see that the layer has results and features were returned.
            if(query.results[path]) {
                html += Application.renderFeaturesWithTemplate(query, path, this.template);
            }

            // and footer contents.
            html += Application.renderTemplate(path, this.footerTemplate, query);
        }


        // return the html for rendering.
        return html;
    }
}

if(typeof(module) !== 'undefined') { module.exports = SelectService; }
